import { render, staticRenderFns } from "./addXWXX.vue?vue&type=template&id=66be7ca2&scoped=true&"
import script from "./addXWXX.vue?vue&type=script&lang=js&"
export * from "./addXWXX.vue?vue&type=script&lang=js&"
import style0 from "./addXWXX.vue?vue&type=style&index=0&id=66be7ca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be7ca2",
  null
  
)

export default component.exports